import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@cmps/ng-bootstrap';
import { SelectModule } from '@cmps/ng-select';
import { CmpsButtonModule, CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsLazyRouterModule } from '../route.module';

import { ChartModule } from './chart/chart.module';
import { CmpsPowerBiReportModule } from './power-bi/power-bi-report.module';
import { ReportsSortArrow } from './reports-sort-arrow.pipe';
import { TranslationIdMap } from './reports.i18n';
import { ReportsRoutes } from './reports.route';
import { ReportsService } from './reports.service';
import { ScatterPlotComponent } from './scatterplot/scatterplot.component';
import { ScatterPlotService } from './scatterplot/scatterplot.services';
import { TdBuilderUsageIndividualSelectionComponent } from './td-builder-usage-individual-selection/td-builder-usage-individual-selection.reports.component';
import { TdBuilderUsageIndividualReportComponent } from './td-builder-usage-individual/td-builder-usage-individual.reports.component';
import { TdBuilderUsageMetricSelectionComponent } from './td-builder-usage-metric-selection/td-builder-usage-metric-selection.reports.component';
import { TdBuilderUsageMetricReportComponent } from './td-builder-usage-metric/td-builder-usage-metric.reports.component';
import { TdComplianceSelectionComponent } from './td-compliance-selection/td-compliance-selection.reports.component';
import { TdComplianceReportComponent } from './td-compliance/td-compliance.reports.component';
import { TdDailyHuddleSelectionComponent } from './td-daily-huddle-selection/td-daily-huddle-selection.reports.component';
import { TdDailyHuddleReportComponent } from './td-daily-huddle/td-daily-huddle.reports.component';
import { TdOffersSelectionComponent } from './td-offers-selection/td-offers-selection.reports.component';
import { TdOffersReportComponent } from './td-offers/td-offers.reports.component';
import { ReportRxRSelectionComponent } from './td-rxr-selection/report_rxr-selection.reports.component';
import { RxRReportComponent } from './td-rxr/rxr.reports.component';
import { ReporTbyTtSelectionComponent } from './td-tbyt-selection/report_tbyt-selection.reports.component';
import { ReportTbytComponent } from './td-tbyt/reports_tbyt.component';
import { UserLoginReportsComponent } from './user-login.reports.component';
import { MultiSelectComponent } from './widgets/multi-select.widget.reports.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        SelectModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsCommonModule,
        CmpsLazyRouterModule.forChild(ReportsRoutes),
        CmpsPowerBiReportModule,
        CmpsButtonModule,
        CmpsIconModule,
        ChartModule,
        ChartModule,
    ],
    declarations: [
        UserLoginReportsComponent,
        ReportsSortArrow,
        MultiSelectComponent,
        TdDailyHuddleSelectionComponent,
        TdDailyHuddleReportComponent,
        ReporTbyTtSelectionComponent,
        ReportTbytComponent,
        ScatterPlotComponent,
        RxRReportComponent,
        ReportRxRSelectionComponent,
        TdComplianceReportComponent,
        TdComplianceSelectionComponent,
        TdOffersReportComponent,
        TdOffersSelectionComponent,
        TdBuilderUsageMetricReportComponent,
        TdBuilderUsageMetricSelectionComponent,
        TdBuilderUsageIndividualReportComponent,
        TdBuilderUsageIndividualSelectionComponent,
    ],
    exports: [
        CmpsPowerBiReportModule, // <-- and export here
    ],
})
export class CmpsReportsModule {
    static forRoot(): ModuleWithProviders<CmpsReportsModule> {
        return {
            ngModule: CmpsReportsModule,
            providers: [ReportsService, ScatterPlotService],
        };
    }
}
